import palazzos from "../../../../public/projects/Trinity/projects/palazzos.webp";
import logo from "../../../../public/projects/Trinity/logo/logo.png"
// Trinity - Sky Palazzos
import overviewImage_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Banner/1.webp";
import bannerDesktopImage_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Banner/1.webp";
import bannerMobileImage_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Banner/2.webp";
import siteVisitBannerImage_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/SiteVisitBanner/1.webp";
import Location_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Location/L1.webp";
import Hightlights_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Highlights/1.webp";
import floorplan1_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/floorplan/1.webp";
import floorplan2_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/floorplan/2.webp";
import locationicon_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Overview/l.png";
import calicon_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Overview/c.png";
import newlaunchicon_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Overview/n.png";
import Gallery1_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Gallery/1.webp";
import Gallery2_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Gallery/2.webp";
import Gallery3_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Gallery/3.webp";
import Gallery4_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Gallery/4.webp";
import Gallery5_skypalazzos from "../../../../public/projects/Trinity/images/palazzos/Gallery/5.webp";

export const developersTrinity = {
  properties: [
    {
      name: "Trinity - SKY Palazzos ",
      image: palazzos,
      price: "On Request",
      location: "Sector 88B",
      projectlocation: "Dwarka Expressway,",
      bed: "3 - 4 BHK",
      developer: "Trinity",
      state: "Gurugram",
      size: "....",
      url: `/trinity-palazzos-sector-88b-gurugram`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: `2023`,
  },
  about: `Trinity Infratech, led by Mukund Mittal, is a premium real estate developer in Gurugram, specializing in luxury residential and commercial 
  projects. Known for innovation, quality, and sustainability, the company aims to redefine urban living with contemporary architecture, spacious layouts,
   and top-tier amenities. Committed to excellence, it has earned recognition for delivering high-end, customer-centric developments.

`,
};

export const projectsTrinity = {
  palazzos: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_skypalazzos,
      bannerMobileImage: bannerMobileImage_skypalazzos,
      textOverlay: "",
      data: {
        title: "Trinity SKY Palazzos",
        subtitle: "Sector 88B, Dwarka Expressway, Gurgaon",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "Applied",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Trinity SKY Palazzos",
      description: [
        `Looking for a Residential building in Gurgaon, here we present to you one of the best Residential properties named Trinity SKY Palazzos Sector 88
         offered by one of the prominent builders named Trinity Sector 88. This luxury Residential property is been located in New Gurgaon, Gurugram. 
         This location is presenting excellent connectivity to all the locations around the city. The professional who has worked on this property are 
         well proficient and successfully designed many great projects. A panoramic and residential center with incorporated outdoor bazaars that have
          a unique triangular shape, which ensures maximum visibility. There are beautiful landscapes and greenery over the land for a fresh & healthy 
          atmosphere. After the fulfillment of the possession of several residential projects of coordinated housing, it will be a high-density population
           area. Therefore, we can say that the Trinity SKY Palazzos Sector 88 New Gurgaon Residential Gurgaon. Residential sector that is conveniently 
           situated closer to NH-48 and Dwarka Expressway, both established just 2.5 km away, and consequently, it appreciates good connectivity with the 
           rest of Gurgaon.`,
      ],
      image: overviewImage_skypalazzos,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_skypalazzos,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_skypalazzos,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_skypalazzos,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_skypalazzos,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "....",
          price: "On Request",
        },
        {
          type: "3 BHK ",
          area: "....",
          price: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "....",
        price: "On Request",
        image: floorplan1_skypalazzos,
      },
      {
        type: "3 BHK ",
        area: "....",
        price: "On Request",
        image: floorplan2_skypalazzos,
      },
    ],

    highlights: {
      images: Hightlights_skypalazzos,
      tagline: "Highlights",
      features: [
        "Premium Location with Excellent Connectivity",
        "Sky Palazzos Sector 88b offers spacious apartments with private decks and lobby areas",
        "Well-Connected to IMT Manesar & Pataudi Road",
        "Just 10 minutes from NH-48",
        "Vicinity to Commercial and IT hub .",
      ],
    },

    location: {
      image: Location_skypalazzos,
      data: [
        {
          airport: {
            distance_time: "29 km",
            name: "IGI Airport",
          },
          school: {
            distance_time: "30 Km",
            name: "The Indian School",
          },
          railwayormetro: {
            distance_time: "21 Km",
            name: "Sikanderpur Metro Station",
          },
          hospital: {
            distance_time: "32 Km",
            name: " Fortis Flt Lt Rajan Dhall Hospital",
          },
          mall: {
            distance_time: "23 Km",
            name: "Ambience Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: Gallery1_skypalazzos },
        { image: Gallery2_skypalazzos },
        { image: Gallery3_skypalazzos },
        { image: Gallery4_skypalazzos },
        { image: Gallery5_skypalazzos },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Trinity Palazzos kindly share more details.",
    },

    faq: [],
    similar: {},
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
